// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__ytvqH","messages":"Chat_messages__3TYhJ","dateDivider":"Chat_dateDivider__4vqT5"};